import React from 'react';
import { motion } from 'framer-motion';
export function CentralPromise() {
  return <section className="py-24 bg-[#0A0A0A] relative overflow-hidden" data-id="element-1">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-2"></div>

      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center" data-id="element-3">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-4">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-[#FAF7F2] leading-tight mb-12" data-id="element-5">
            Una inmersión donde no vienes a “aprender trucos”, vienes a{' '}
            <span className="text-[#C5A55A] italic" data-id="element-6">volver a encontrarte</span>{' '}
            desde un lugar más profundo, consciente y vivo.
          </h2>

          <div className="w-full h-px bg-gradient-to-r from-transparent via-[#C5A55A]/50 to-transparent my-12" data-id="element-7"></div>

          <div className="text-left md:text-center" data-id="element-8">
            <p className="text-[#FAF7F2]/70 text-lg uppercase tracking-widest mb-4" data-id="element-9">
              Y sí, lo tangible importa:
            </p>
            <p className="text-xl md:text-2xl text-[#FAF7F2] font-light leading-relaxed" data-id="element-10">
              Vas a salir con{' '}
              <span className="font-bold text-[#C5A55A]" data-id="element-11">
                18 métodos prácticos
              </span>{' '}
              de profundizar la intimidad, elegir lo que hoy necesita tu
              relación y crear un nuevo comienzo —
              <span className="italic" data-id="element-12">no solo una noche bonita.</span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}